export default "__VITE_ASSET__qUmTfsQU__"